<template>
<!-- это просто компонент для вывода программ, не содержащий избыточной логики – он просто принимает массив с ОП как пропс  -->
  <el-dialog class="dialog" :visible="visible" :append-to-body="true" :close-on-click-modal="false" @close="$emit('close')">
    <div class="dialog-programs dialog__inner">
      <div class="dialog-programs__column dialog-programs__column_aside">
        <div slot="title" class="dialog__head dialog__head_second">
          <div class="dialog__head-inner">
            <h2 class="dialog__title">
              {{heading}}
            </h2>
          </div>
        </div>


        <div v-if="programs.length === 0" style="text-align: center; color: #e2e2e2;">
          Нет образовательных программ
        </div>

        <div class="programs-list programs-list_vertical dialog-programs__programs-list">
          <div class="programs-list__inner">
            <el-checkbox-group>
              <div class="programs-list__item" v-for="program in programs" :key="program.id"  @click="editProgram(program)">
                <div class="programs-list__content">
                  <div class="programs-list__content-item programs-list__content-item_main">
                                            <span class="programs-list__checkbox-wrap">
                                                <span class="programs-list__text pl-0" v-html="program.name"></span>
                                            </span>
                  </div>

                </div>

                <footer class="programs-list__footer">
                  Повышение квалификации
<!--                  <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
<!--                    <icon-arrow-right />-->
<!--                  </icon-base>-->
                </footer>
              </div>
            </el-checkbox-group>
          </div>
        </div>

      </div>

      <div class="dialog-programs__column dialog-programs__column_main is-active" v-if="programInEdit">
        <div>
          <header class="program__head">
            <h2 class="dialog__title">Образовательная программа</h2>
          </header>

          <div class="program__content">
            <section class="program__section">
              <h2 class="program__title">Основная информация</h2>

              <span class="input" v-html="programInEdit.name"></span>

              <span class="textarea mt-8" v-html="programInEdit.description" v-if="programInEdit.description"></span>

<!--              <span class="input mt-8" v-html="editSelect.name"></span>-->
            </section>

            <section class="program__section">
              <h2 class="program__title">Контакты организации</h2>

              <h4>Название организации</h4>

              <div class="contacts">
                <div class="contacts__row">
                  <div class="contacts__item">
                    <span class="input" v-html="programInEdit.contact ? programInEdit.contact.name : ''"></span>
                  </div>

                  <div class="contacts__item">
                    <span class="input" v-html="programInEdit.contact ? programInEdit.contact.phone : ''"></span>
                  </div>
                </div>
                <div class="contacts__row">
                  <div class="contacts__item">
                    <span class="input" v-html="programInEdit.contact ? programInEdit.contact.address : ''"></span>
                  </div>

                  <div class="contacts__item">
                    <span class="input" v-html="programInEdit.contact ? programInEdit.contact.link : ''"></span>
                  </div>
                </div>
                <div class="contacts__row" v-if="programInEdit.program_link">
                  <div class="contacts__item">
                    <span class="input" v-html="programInEdit.program_link"></span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import dialog from "@/mixins/dialog";
import mapState from "vuex";

export default {
  mixins: [ dialog ],
  name: "ProgramsDialogView",
  data() {
    return {
      show: true,
      programInEdit: null,
    }
  },
  props: {
    heading: {
      type: String,
      default: 'Список образовательных программ',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    programs: {
      type: Array,
      required: true,
    }
  },
  methods: {
    editProgram(program) {
      this.programInEdit = program;
    },
  }
}
</script>